import { render, staticRenderFns } from "./BelongedAllDepartmentsUserFilter.vue?vue&type=template&id=4a89a87b&scoped=true&"
import script from "./BelongedAllDepartmentsUserFilter.vue?vue&type=script&lang=ts&"
export * from "./BelongedAllDepartmentsUserFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89a87b",
  null
  
)

export default component.exports